import Component from "../abstracts/Component";
import { doAjax } from "../utils/ajaxUtil";
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";
import {algoliaAddToWishlist} from "../utils/algoliaTrackings";

export default class WishlistComponent extends Component {
  get SELECTORS() {
    return {
      container: ".js-wishlist-dropdown",
      main: ".js-wishlist",
      item: ".wishlist .product-item",
      sizeLayer: ".js-sizes",
      addedMsg: ".item-added",
      icon: ".action.wishlist",
      remove: ".js-remove-wish",
      emptyWish: ".js-empty-wishlist-msg",
      qty: ".qty-items",
      wishlistLink: ".js-addtowishlist-link",
      nav_wishlist: ".wishlist-nav",
      qtyWishlist: ".wishlistCount",
      qtyWishlistTitle: ".wishlistCount-title",
      qtyWishlistMobile: ".wishlistCount-mobile",
      wishlistEmptySection: "[data-wishlist-empty]",
      wishlistFullSection: "[data-wishlist-full]",
      wishBtn: ".js-wishlist-cta"
    };
  }

  get CLASSES() {
    return {
      show: "show",
      active: "active",
      removing: "removing",
      icon_wishlist_on: "icon-wishlist-on",
      icon_wishlist_off: "icon-wishlist-off",

      deleteBtnClass: "delete",
      addBtnClass: "js-addtowish",
      addedBtnClass: "js-added-wish",
      removeBtnClass: "js-remove-from-wish",
      iconWishlistEmpty: "icon-wishlist-empty",
      iconWishlistFull: "icon-wishlist-full",
      listingClassRemove: "product-card--wishlist",
      listingClassAdd: "product-card--wishlist-grey",
      error: "error"
    };
  }

  constructor() {
    super();
    this.timeout = null;
    this.container = $(this.SELECTORS.container);
    this.main = $(this.SELECTORS.main);
    this.item = $(this.SELECTORS.item);
    this.sizeLayer = $(this.SELECTORS.sizeLayer);
    this.addedMsg = $(this.SELECTORS.addedMsg);
    this.icon = $(this.SELECTORS.icon);
    this.remove = $(this.SELECTORS.remove);
    this.updated = false;
    this.qtyWishlist = $(this.SELECTORS.qtyWishlist);
    this.qtyWishlistMobile = $(this.SELECTORS.qtyWishlistMobile);
    this.qtyWishlistTitle = $(this.SELECTORS.qtyWishlistTitle);
    this.wishlistEmptySection = document.querySelector(
      this.SELECTORS.wishlistEmptySection
    );
    this.wishlistFullSection = document.querySelector(
      this.SELECTORS.wishlistFullSection
    );
    this.wishBtn = document.querySelectorAll(this.SELECTORS.wishBtn);
    this.wishlistLink = document.querySelector(this.SELECTORS.wishlistLink);
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000
    });
  }

  removeProduct(el) {
    let ctx = this;
    let $elem = $(el);
    let url = $elem.data("href");
    let code = $elem.data("code");
    el.disabled = true;

    $.ajax({
      url: url,
      dataType: "json",
      data: {
        productCode: code
      },
      type: "POST",
      success: function(resp) {
        let qty = resp.count;
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, {
          elem: el,
          qty: qty
        });
      },
      error: function(xhr) {
        console.log(xhr);
      },
      complete: function() {
        el.disabled = false;
      }
    });
  }

  updateQtyWishlist() {
    let ctx = this;
    let qtyNew = ctx.qtyWishlist.text() - 1;
    ctx.qtyWishlist.text(qtyNew);
    ctx.qtyWishlistMobile.text(qtyNew);
    let qtyNewTitle = ctx.qtyWishlistTitle;
    if (qtyNewTitle != null || typeof qtyNewTitle !== "undefined") {
      qtyNewTitle.text(" (" + qtyNew + ")");
    }
    console.log(this.wishlistLink);
    //update aria label
    if (this.wishlistLink) {
      this.wishlistLink.setAttribute(
        "aria-label",
        this.wishlistLink.dataset.ariaLabel + " " + qtyNew
      );
    }
  }

  deleteQtyWishlist() {
    let ctx = this;
    let qtyNew = parseInt(ctx.qtyWishlist.text()) - 1;
    if (qtyNew < 0) qty = 0;
    ctx.qtyWishlist.text(qtyNew);
    ctx.qtyWishlistMobile.text(qtyNew);
    console.log(this.wishlistLink);
    if (this.wishlistLink) {
      this.wishlistLink.setAttribute(
        "aria-label",
        this.wishlistLink.dataset.ariaLabel + " " + qtyNew
      );
    }
  }

  addQtyWishlist() {
    let ctx = this;
    let qtyNew = parseInt(ctx.qtyWishlist.text()) + 1;
    ctx.qtyWishlist.text(qtyNew);
    ctx.qtyWishlistMobile.text(qtyNew);
    console.log(this.wishlistLink);
    if (this.wishlistLink) {
      this.wishlistLink.setAttribute(
        "aria-label",
        this.wishlistLink.dataset.ariaLabel + " " + qtyNew
      );
    }
  }

  wishlistCheckAjax(code) {
    return new Promise((resolve, reject) => {
      let data = {};
      data[code] = code;
      //
      let contextPath = document
        .getElementsByTagName("HTML")[0]
        .getAttribute("data-context");
      $.ajax({
        url: contextPath + "/action/ajax/wishlist-check-product",
        data: {
          code: code
        },
        success: function(result) {
          // resolve
          resolve(result);
        }
      });
    });
  }
  updateWishButton(btn, disable) {
    // check
    if (btn == null) return false;
    //
    if (disable == true) {
      // disable button
      btn.classList.remove(this.CLASSES.addBtnClass);
      btn.classList.add(this.CLASSES.addedBtnClass);
      btn.classList.add(this.CLASSES.removeBtnClass);
    } else {
      // enable button
      btn.classList.add(this.CLASSES.addBtnClass);
      btn.classList.remove(this.CLASSES.addedBtnClass);
      btn.classList.remove(this.CLASSES.removeBtnClass);
    }
  }
  selectedSize(target) {
    const ctx = this;
    const parent = $(target)
      .parent()
      .parent();
    let sizeSelected;
    let sizes = parent.siblings(ctx.SELECTORS.sizesForm)[0];
    if (typeof sizes === "undefined") {
      sizes = parent.parent().siblings(ctx.SELECTORS.sizesForm)[0];
    }
    if ($(sizes).find(".c-pdp-s__select-size").length !== 0) {
      sizeSelected = $(sizes)
        .find(".c-pdp-s__item.selected")
        .data("productCode");
    } else {
      sizeSelected = $(target).data("code");
    }
    return sizeSelected;
  }

  // listen to click
  listenBtnWish(btns) {
    // global
    let ctx = this;
    // if not passed
    if (typeof btns == "undefined") btns = this.wishBtn;
    //
    if (btns != null) {
      btns.forEach(btn => {
        btn.addEventListener("click", elem => {
          // no default action
          elem.stopPropagation();
          // in base of button class
          if (btn.classList.contains(ctx.CLASSES.addBtnClass)) {
            // adding
            let url = btn.getAttribute("data-wish-add-url");
            ctx.addToWishlist(btn, url);
          } else {
            // removing
            let url = btn.getAttribute("data-wish-remove-url");
            ctx.removeToWishlist(btn, url);
          }
        });
      });
    }
  }

  addToWishlist(elem, url) {
    let ctx = this;
    let productCode =
      elem.dataset.code ||
      elem.getAttribute('data-code') ||
      elem.closest('[data-code]')?.dataset.code;

    if (!productCode) {
      console.warn('Wishlist: productCode non trovato');
      return;
    }

    elem.disabled = true;
    const labelAdded  = elem.dataset.labelAdded;
    const labelRemove = elem.dataset.labelRemove;

    // --- AJAX app ---
    doAjax({
      url,
      data: { code: productCode },
      dataType: "html",
      success(resp) {
        ctx.log("added to wishlist", productCode);
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, { elem, qty: resp });
        ctx.liveRegion.sayMessage(labelAdded);
        elem.setAttribute("aria-label", labelRemove);
      },
      error() {
        console.log("error in add to wishlist");
      },
      complete() {
        elem.disabled = false;
      }
    });

    const algoliaQueryId =
      document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId ||
      document.querySelector('[data-algolia-search]')?.dataset?.algoliaSearch;

    if (!algoliaQueryId) {
      console.warn("Algolia query ID not found (sei in PDP senza ripristino?)");
    } else {
      try {
        algoliaAddToWishlist(productCode);
      } catch (e) {
        console.warn("algoliaAddToWishlist errore:", e);
      }
    }
  }
  removeToWishlist(elem, url) {
    // vars
    let ctx = this;
    let code = elem.dataset.code;
    elem.disabled = true;
    const labelRemoved = elem.dataset.labelRemoved;
    const labelAdd = elem.dataset.labelAdd;
    // ajax
    doAjax({
      url: url,
      dataType: "json",
      data: {
        productCode: code
      },
      type: "POST",
      success: function(resp) {
        // n of items on wishlist
        let qty = resp.count;
        // launch event
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedToWish, {
          elem: elem,
          qty: qty
        });
        ctx.liveRegion.sayMessage(labelRemoved);
        elem.setAttribute("aria-label", labelAdd);
      },
      error: function(xhr) {
        console.log(xhr);
      },
      complete: function() {
        elem.disabled = false;
      }
    });
  }

  bindEvents() {
    let ctx = this;

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.addedtocart,
      ({ event, payload }) => {
        //Remove from miniwishlist when selecting a size in miniwishlist
        let fromMiniWislist = $(payload.button).data("from-wishlist");
      }
    );

    this.$on(this.$customEvents.PRODUCT_EVENTS.addtowish, e => {
      let $elem = $(e.payload);
      let url = $elem.data("href");
      this.originalFocus = e.payload;

      $.ajax({
        url: url,
        data: {
          code: $elem.data("code")
        },
        dataType: "html",
        success: function(resp) {
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, $elem);
          let qty = resp;
          $(ctx.SELECTORS.qty).text(qty);
        },
        error: function(xhr) {
          console.log("error in add to wishlist");
        }
      });
    });

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.addedtowish,
      ({ event, payload }) => {
        if (payload.qty !== undefined) {
          this.qtyWishlist.text(payload.qty);
          this.qtyWishlistMobile.text(payload.qty);
        } else {
          this.addQtyWishlist(); // fallback
        }
        this.updateWishButton(payload.elem, true);
        if (this.wishlistLink) {
          this.wishlistLink.setAttribute(
            "aria-label",
            this.wishlistLink.dataset.ariaLabel + " " + payload.qty
          );
        }
      }
    );

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.removedToWish,
      ({ event, payload }) => {
        if (payload.qty !== undefined) {
          this.qtyWishlist.text(payload.qty);
          this.qtyWishlistMobile.text(payload.qty);
        } else {
          this.deleteQtyWishlist(); // fallback
        }
        this.updateWishButton(payload.elem, false);
        if (this.wishlistLink) {
          this.wishlistLink.setAttribute(
            "aria-label",
            this.wishlistLink.dataset.ariaLabel + " " + payload.qty
          );
        }
      }
    );

    //    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, () => {
    //      alert('size changed');
    //      // wishlist check
    //    });
    // event on select size - i want to wishlist the product with the size
    this.$on(
      this.$customEvents.PRODUCT_EVENTS.sizechanged,
      ({ event, payload }) => {
        // search the btn with the base product code
        let btnWish =
          document.querySelector(
            '[data-wishlist-code="' +
              payload.button.offsetParent.dataset.productCode +
              '"]'
          ) ?? null;
        if (btnWish) {
          let btnWishq = document.querySelector(".icon-cta.cta-wishlist");
          let $this = $(this);
          let sendRequest = payload.button.dataset.productCode;

          // put in the button the size code
          btnWish.dataset.code = sendRequest;
          //btnWish.dataset.wishlistCode = sendRequest;

          // check size on size seleect
          // go promise
          this.wishlistCheckAjax(sendRequest).then(result => {
            // result
            if (result === "true") {
              // if is in WL i disable the button
              this.updateWishButton(btnWish, true);
            } else {
              // if not i enable it
              this.updateWishButton(btnWish, false);
            }
          });
        }
      }
    );

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, e => {
      let ctx = this;
      let $elem = $(e.payload);
      const deletedLabel = e.payload.elem.dataset.labelRemoved;

      const deletedBtn = e?.payload?.elem ? e.payload.elem : e?.payload;
      if (deletedBtn && deletedBtn?.disabled) {
        deletedBtn.disabled = false;
      }

      let code = "";
      let $qty = e?.payload?.qty;
      if ($qty > 0) {
        if (ctx.wishlistFullSection?.classList?.contains("hidden")) {
          ctx.wishlistFullSection?.classList?.remove("hidden");
          ctx.wishlistEmptySection?.classList?.add("hidden");
        }
      } else {
        if (ctx.wishlistEmptySection?.classList?.contains("hidden")) {
          ctx.wishlistEmptySection?.classList?.remove("hidden");
          ctx.wishlistFullSection?.classList?.add("hidden");
        }
      }

      if (e.payload.elem == null || typeof e.payload.elem == "undefined") {
        code = e.payload.dataset.code;
      } else {
        code = e.payload.elem.dataset.code;
      }
      let item = $(`div[data-code="${code}"]`);

      item.addClass(ctx.CLASSES.removing);
      this.updateQtyWishlist();
      this.updateWishButton(e.payload.elem, false);
      setTimeout(function() {
        item.remove();
        ctx.liveRegion.sayMessage(deletedLabel);
      }, 800);
    });

    $("body")
      .off("click.wishlist")
      .on("click.wishlist", ctx.SELECTORS.remove, function() {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, this);
      });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removefromwish, e => {
      this.removeProduct(e.payload);
    });

    // Reinizializza i pulsanti wishlist quando vengono caricati nuovi prodotti tramite filtri/paginazione
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({ payload }) => {
      let btns = document.querySelectorAll(ctx.SELECTORS.wishBtn);
      if (btns != null) {
        ctx.listenBtnWish(btns);
      }
    });

    // Reinizializza i pulsanti wishlist quando vengono caricati nuovi prodotti tramite infinite scroll
    this.$on(
      this.$customEvents.INFINITE_SCROLL_EVENTS.loaded,
      ({ event, payload }) => {
        const { newProducts } = payload;
        if (newProducts) {
          const btns = [...newProducts]
            .map(productCard =>
              productCard.querySelector(ctx.SELECTORS.wishBtn)
            )
            .filter(btn => btn !== null);
          if (btns.length > 0) {
            ctx.listenBtnWish(btns);
          }
        }
      }
    );
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
    // add btn
    this.listenBtnWish();
  }
}
